export const months = [
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
];

export const initialGridData = [
  { Month: 'July', Free: 0, Reduced: 0, Paid: 0, Total: 0 },
  { Month: 'August', Free: 0, Reduced: 0, Paid: 0, Total: 0 },
  { Month: 'September', Free: 0, Reduced: 0, Paid: 0, Total: 0 },
  { Month: 'October', Free: 0, Reduced: 0, Paid: 0, Total: 0 },
  { Month: 'November', Free: 0, Reduced: 0, Paid: 0, Total: 0 },
  { Month: 'December', Free: 0, Reduced: 0, Paid: 0, Total: 0 },
  { Month: 'January', Free: 0, Reduced: 0, Paid: 0, Total: 0 },
  { Month: 'February', Free: 0, Reduced: 0, Paid: 0, Total: 0 },
  { Month: 'March', Free: 0, Reduced: 0, Paid: 0, Total: 0 },
  { Month: 'April', Free: 0, Reduced: 0, Paid: 0, Total: 0 },
  { Month: 'May', Free: 0, Reduced: 0, Paid: 0, Total: 0 },
  { Month: 'June', Free: 0, Reduced: 0, Paid: 0, Total: 0 },
];



// WEBPACK FOOTER //
// ./src/pages/provision2baseratessetup/helpers/constants.js